import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import axiosPrivate from '../hooks/useAxiosPrivate'
import useAuth from '../hooks/useAuth'

import NextAppointmentCard from './NextAppointmentCard'

const NextAppointment = () => {
  const { auth } = useAuth()

  const navigate = useNavigate()
  const axios = axiosPrivate();

  const [showNextAppointment, setShowNextAppointment] = useState(false)
  const [nextAppointments, setNextAppointments] = useState(null)

  useEffect(() => {
    fetchLatest()
  }, [])

  const editAppointmentClicked = (appointment) => {
    navigate(`/referral/${appointment.booking_id}`, {
      state: {
        booking: appointment.booking_id, // replace with your actual data object
      },
    })
  }

  const fetchLatest = async () => {
    try {
      const response = await axios.get(
        `/bookings/next-booking/${auth?.user?.id}`,
        { local: true }
      )
      setNextAppointments(response.data.result)
      if (response.data.result.length >0) {
        setShowNextAppointment(true)
      }
    } catch (error) {
      console.error('Error fetching resources:', error)
    }
  }

  return (
    <div className="mt-2 mb-2">
      {showNextAppointment ? (
        <>
          <h2 className="text-xl font-medium pb-4">Your Upcoming Appointments</h2>
          <div className="w-full flex justify-start gap-8 flex-wrap">
            {nextAppointments.map((nextAppointment) => (
              <NextAppointmentCard
                key={nextAppointment.id}
                appointment={nextAppointment}
                onClick={() => editAppointmentClicked(nextAppointment)}
              />
            ))}
          </div>
        </>
      ) : (
        <p>No Upcoming Appointments</p>
      )}
    </div>
  )
}

export default NextAppointment
